import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, Users, LogOut, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const EventSelector = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    toast.success('Úspěšně odhlášen');
    navigate('/admin/login');
  };

  const events = [
    {
      id: 'kontakt-fest-2026',
      name: 'KONTAKT Fest 2026',
      date: '13. - 14. června 2026',
      location: 'Frenštát pod Radhoštěm - Trojanovice',
      color: 'from-orange-500 to-amber-500',
      icon: '🎪',
      stats: {
        total: 0,
        pending: 0,
        approved: 0
      }
    },
    {
      id: 'cesta-kolem-sveta-2026',
      name: 'Gastrofestival Cesta Kolem Světa',
      date: '16. - 17. května 2026',
      location: 'Masarykovo náměstí, Uherské Hradiště',
      color: 'from-green-600 to-yellow-500',
      icon: '🌍',
      stats: {
        total: 0,
        pending: 0,
        approved: 0
      }
    },
    {
      id: 'majofest-otrokovice-2026',
      name: 'Májofest Otrokovice',
      date: '2. května 2026',
      location: 'Otrokovice',
      color: 'from-teal-500 to-amber-500',
      icon: '🍺',
      stats: {
        total: 0,
        pending: 0,
        approved: 0
      }
    },
    {
      id: 'burger-rock-fest-2026',
      name: 'Burger Rock Fest',
      date: '6. června 2026',
      location: 'Nádvoří Nového Kláštera, Napajedla',
      color: 'from-yellow-500 to-red-600',
      icon: '🍔',
      stats: {
        total: 0,
        pending: 0,
        approved: 0
      }
    },
    {
      id: 'otrokovicke-letni-slavnosti-2026',
      name: 'Otrokovické letní slavnosti',
      date: '10. - 11. července 2026',
      location: 'Park před Společenským domem, Otrokovice',
      color: 'from-cyan-500 to-blue-500',
      icon: '☀️',
      stats: {
        total: 0,
        pending: 0,
        approved: 0
      }
    },
    {
      id: 'festival-koupacek-2026',
      name: 'Festival Koupáček',
      date: '5. července 2026',
      location: 'Městské koupaliště, Otrokovice',
      color: 'from-cyan-400 to-blue-600',
      icon: '💦',
      stats: {
        total: 0,
        pending: 0,
        approved: 0
      }
    }
  ];

  const handleEventSelect = (eventId) => {
    navigate(`/admin/dashboard/${eventId}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-4xl font-bold text-slate-900 mb-2">
              Admin Panel
            </h1>
            <p className="text-slate-600">
              Vyberte akci pro správu přihlášek
            </p>
          </div>
          <Button
            onClick={handleLogout}
            variant="outline"
            className="border-2"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Odhlásit se
          </Button>
        </div>

        {/* Event Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map((event) => (
            <Card 
              key={event.id}
              className="border-2 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105"
              onClick={() => handleEventSelect(event.id)}
            >
              <CardContent className="p-0">
                {/* Header s gradientem */}
                <div className={`bg-gradient-to-r ${event.color} p-6 text-white`}>
                  <div className="text-6xl mb-4 text-center">
                    {event.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-center mb-2">
                    {event.name}
                  </h3>
                </div>

                {/* Info sekce */}
                <div className="p-6 space-y-4">
                  <div className="flex items-center gap-2 text-slate-700">
                    <Calendar className="w-5 h-5 text-orange-500" />
                    <span className="font-semibold">{event.date}</span>
                  </div>
                  
                  <div className="flex items-center gap-2 text-slate-700">
                    <Users className="w-5 h-5 text-orange-500" />
                    <span>{event.location}</span>
                  </div>

                  {/* Statistiky - placeholder pro budoucnost */}
                  {/* <div className="pt-4 border-t border-slate-200">
                    <div className="grid grid-cols-3 gap-2 text-center">
                      <div>
                        <div className="text-2xl font-bold text-slate-900">{event.stats.total}</div>
                        <div className="text-xs text-slate-600">Celkem</div>
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-yellow-600">{event.stats.pending}</div>
                        <div className="text-xs text-slate-600">Čeká</div>
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-green-600">{event.stats.approved}</div>
                        <div className="text-xs text-slate-600">Schváleno</div>
                      </div>
                    </div>
                  </div> */}

                  {/* Tlačítko */}
                  <Button 
                    className={`w-full bg-gradient-to-r ${event.color} text-white hover:opacity-90`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEventSelect(event.id);
                    }}
                  >
                    Otevřít dashboard
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Placeholder pro přidání další akce */}
        <Card className="mt-6 border-2 border-dashed border-slate-300 bg-slate-50">
          <CardContent className="p-12 text-center">
            <div className="text-6xl mb-4">➕</div>
            <h3 className="text-xl font-bold text-slate-700 mb-2">
              Další festivaly
            </h3>
            <p className="text-slate-600">
              V budoucnu zde přibydou další akce
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EventSelector;
